import cls from "classnames";
import WordmarkDrawing from "images/logo.svg?react";
import styles from "./Wordmark.module.scss";

type Props = {
  className?: string;
};

/** The Talaera wordmark, in the page's ink: the logo of the pages outside the app shell. */
export default function Wordmark(props: Props) {
  return (
    <WordmarkDrawing
      className={cls(styles.wordmark, props.className)}
      role="img"
      aria-label="Talaera"
    />
  );
}
